import { render, staticRenderFns } from "./ProfileAppointment.vue?vue&type=template&id=6461e1c5&"
import script from "./ProfileAppointment.vue?vue&type=script&lang=js&"
export * from "./ProfileAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports